<template>
    <div :class="containerClasses" :id="id">
        <div v-for="(item,key) in itemList" :class="itemClasses" :key="k">
            <div :class="itemHeaderClasses">
                <a class="stretched-link" :href="'#'+item.link" data-toggle="collapse" :data-target="'#'+item.link">
                    <span :class="itemIconClasses"></span>
                    {{ item.label }}
                </a>
            </div>
            <div :key="k" :class="'collapse ' + (k===activeIndex?'show':'')" :id="item.link" :data-parent="'#'+id">
                <div :class="itemBodyClasses">
                    {{ item.content }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        containerClasses: {
            type: String,
            default: "shadow-sm rounded-lg"
        },
        id: {
            type: String,
            default: "acc"
        },
        activeIndex: {
            type: Number,
            default: 0
        },
        items: {
            type: Array,
            default(){
                return [
                    {label:"Item 1", link:"item_1", content:"Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt raw denim aesthetic synth nesciunt sapiente ea proident. Aus labore sustainable VHS."},
                    {label:"Item 2", link:"item_2", content:"Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod."},
                    {label:"Item 3", link:"item_3", content:"Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda."}
                ]
            }
        },
        itemClasses: {
            type: String,
            default: "card"
        },
        itemHeaderClasses: {
            type: String,
            default: "card-header"
        },
        itemBodyClasses: {
            type: String,
            default: "card-body"
        },
        itemIconClasses: {
            type: String,
            default: "float-right mt-1 icons icon-options-vertical"
        }
    },
    data() {
        return {
          itemList: this.items||[]
        };
    }
};
</script>
